const path = require('path');

module.exports = {
  i18n: {
    defaultLocale: 'ja',
    locales: ['en', 'ja', 'ko', 'tw', 'vi'],
    localeDetection: false,
    serializeConfig: false,
    reloadOnPrerender: true,
    localePath: path.resolve('./static/locales'),
  },
};
